<template>
  <component :is="component" />
</template>

<script>


import yuanLinKongZhiQi23Group from "./yuanLinKongZhiQi23/group.vue"
import yuanLinKongZhiQi24Group from "./yuanLinKongZhiQi24/group.vue"

export default {

  components: { yuanLinKongZhiQi23Group, yuanLinKongZhiQi24Group },

  data () {
    return {
      component: null
    }
  },

  mounted () {
    this.renderComponent()
  },

  methods: {
    renderComponent () {
      const type = sessionStorage.getItem("deviceType")
      console.log("园林控制器类的轮灌组 根据type挂载不同的组件  group:", type);

      if (type == 23) {
        this.component = yuanLinKongZhiQi23Group
      } else {
        this.component = yuanLinKongZhiQi24Group
      }
    }
  }
}
</script>

<style></style>
